module.exports = __webpack_public_path__ + "static/media/s6_1.032875b2.ogg";